export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                //Font
                'tw-text-sm',
                // Spacing
                'tw-px-2 tw-py-0.5',
                // Shape
                {
                    'tw-rounded-md': !props.rounded,
                    'tw-rounded-full': props.rounded,
                },
                // Colors
                'tw-text-primary-contrast',
                {
                    'tw-bg-primary dark:tw-bg-primary': props.severity == null || props.severity === 'primary',
                    'tw-text-zinc-800 dark:tw-text-zinc-300 tw-bg-gray-200/70 dark:tw-bg-zinc-500/20': props.severity === 'secondary',
                    'tw-bg-green-500 dark:tw-bg-green-400': props.severity === 'success',
                    'tw-bg-blue-500 dark:tw-bg-blue-400': props.severity === 'info',
                    'tw-bg-orange-500 dark:tw-bg-orange-400': props.severity === 'warn',
                    'tw-bg-red-500 dark:tw-bg-red-400': props.severity === 'danger',
                    'tw-text-zinc-0 dark:tw-text-zinc-900 tw-bg-zinc-900 dark:tw-bg-zinc-0': props.severity === 'contrast',
                },
            ],
        });
    },
    value: {
        class: 'tw-leading-normal',
    },
    icon: {
        class: 'tw-mr-1 tw-text-sm',
    },
};
